export const progressBarOptions = {
    color: '#597dfc',
    failedColor: '#abbdfe',
    thickness: '3px',
    transition: {
        speed: '0.5s',
        opacity: '0.6s',
        termination: 500
    },
    autoRevert: true,
    location: 'top',
    inverse: false
}
